export const siteSettings = {
  name: "Rabiptradefx",
  link: "https://rabiptrade.com",
  email: "support@rabiptrade.com",
  appLink: "https://app.rabiptrade.com",
};
